import { useTranslation } from 'react-i18next';
import { Form, Modal, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useUpdateWarehouseTaskStatus } from 'api/warehouse-task/use-update-warehouse-task-status';
import { validationRules } from './constants';
import type { IStatusOption, IWhTaskStatusFormFields, IWhTaskStatusEditModalProps } from './types';
import { getAvailableStatuses } from './utils';

export const WhTaskStatusEditModal = (props: IWhTaskStatusEditModalProps) => {
  const { isOpen, onClose, whTask } = props;
  const { t } = useTranslation('wh-task');

  const { mutateAsync: updateStatus, isLoading } = useUpdateWarehouseTaskStatus(whTask.id);

  const [form] = Form.useForm();
  const handleOk = debounce(() => form.submit(), 200);

  const onFinish = async (values: IWhTaskStatusFormFields) => {
    await updateStatus(values);
    onClose();
  };

  const statuses: IStatusOption[] = [
    { value: 'waiting', label: t('waiting_status') },
    { value: 'progress', label: t('progress_status') },
    { value: 'done', label: t('done_status') },
    { value: 'cancelled', label: t('cancelled_status') },
  ];

  const preparedStatuses: IStatusOption[] = statuses.map((status) => {
    const availableStatuses = getAvailableStatuses(whTask.status);

    return {
      ...status,
      disabled: !availableStatuses[status.value],
    };
  });

  return (
    <Modal title={t('edit_status')} open={isOpen} confirmLoading={isLoading} onCancel={onClose} onOk={handleOk}>
      <Form
        form={form}
        name='wh_task_status'
        layout='vertical'
        initialValues={{ status: whTask.status }}
        onFinish={onFinish}>
        <Form.Item name='status' rules={validationRules.status}>
          <Select placeholder={t('common:status')} size={'large'} options={preparedStatuses} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
